// Stub for @uptrace/web.
//
// @azmed-org/azcomponents (>=1.1.0) declares @uptrace/web as a peer dependency
// and imports `configureOpentelemetry` in its opt-in observability module
// (`initObservability`). The viewer never calls that function, but Webpack 4
// still has to resolve the import. Rather than bundle the full telemetry SDK
// (and take on its ESM/Webpack-4 compat cost), we alias @uptrace/web to this
// no-op so observability stays inert. If the viewer ever needs real
// observability, install @uptrace/web@^2 and drop this alias.
module.exports = {
  configureOpentelemetry: () => {},
};
